import React, {FC, useEffect, useState} from "react";
import {Animated} from "react-animated-css";
import {Link, useHistory} from "react-router-dom";
import {useLastMessage, useMessages, useThrottledLayoutEffect} from "../api/hooks";
import Footer from "../common/views/Footer";
import {Message} from "../common/types/Types";
import {BYInput} from "../common/inputs/BYInput";
import {BYTable} from "../common/views/BYTable";
import {CommonHelper} from "../common/CommonHelper";

export const MessageList: FC = () => {
    const [searchText, setSearchText] = useState('');
    const history = useHistory();
    const {data: latestMessage} = useLastMessage();

    const {data: messages = [], isLoading} = useMessages();

    const [filteredMessages, setFilteredMessages] = useState<Message[]>(messages);

    useEffect(() => {
        setFilteredMessages(messages);
    }, [messages])

    useThrottledLayoutEffect(() => {
        const filteredMessages = messages.filter((message) => {
            const code = `${message.refMessage} ${message.message}`.toUpperCase();
            const searchTextUpperCased = searchText.toUpperCase();

            return code.includes(searchTextUpperCased);
        });

        setFilteredMessages(filteredMessages);
    }, 300, [searchText, messages]);

    return (
        <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true}>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <h3 className="my-4 color-green">Messages <small
                            className="color-black">({messages.length})</small></h3>
                    </div>
                    <div className="col text-right tittle-buttons">
                        <Link type="submit"
                              className="btn btn-warning"
                              to={`${process.env.PUBLIC_URL}/message/new`}
                        >
                            Créer message <i className="fa fa-plus"></i>
                        </Link>
                    </div>
                </div>

                <div>
                    <div className="mb-3">
                            <BYInput type="text"
                                     title="Rechercher"
                                     placeholder="Description, message d'installation, id etc."
                                     className="form-control"
                                     value={searchText}
                                     onChange={(e) => setSearchText(e.target.value)}/>
                    </div>

                    <BYTable
                        loading={isLoading}
                        data={filteredMessages}
                        columns={['refMessage', 'message', 'dateCreation', 'dateFin', 'createur', 'refCreateur']}
                        columnNames={['Identifiant', 'Message', "Créé le", 'Fini le', 'Créé par', '']}
                        dataTransform={{
                            'dateCreation': (message) => CommonHelper.formatDate(message.dateCreation),
                            'dateFin': (message) => CommonHelper.formatDate(message.dateFin),
                            'createur': (message) => CommonHelper.formatAcquereur(message.createur),
                            'refCreateur': (message) => message.refMessage === latestMessage?.refMessage ? <span className="badge bg-success text-light">Active</span> : ''
                        }}
                        onClick={(message) => {
                            history.push(`/message/${message.refMessage}`);
                        }}
                        keyExtractor={(message) => `message-list-${message.refMessage}`}
                    />
                </div>

            </div>
            <Footer/>
        </Animated>
    );
};
